import { StyleSheet } from "react-native";

import Theme from './theme'

export const SPACING = 8;

const commonStyles = StyleSheet.create({
  textInput: {
    borderColor: "black",
    borderWidth: 1,
    padding: SPACING,
  },

  placeholder: {
    color: Theme.colors.textInfo,
  },

  greedy: {
    flex: 1,
    // justifyContent: "center",
    // alignItems: "stretch",
  },

  separator: {
    height: 1,
    width: "100%",
    backgroundColor: Theme.colors.backgroundDivider,
  },

  grid: {
    flexDirection: "row",
    flexWrap: "wrap",
  },
  gridItem: {
    padding: SPACING,
  },

  list: {
    display: "flex",
    flexDirection: "column",
  },
  listItem: {
    flexDirection: "row",
    margin: SPACING,
    padding: SPACING,
    // boxSizing: "border-box",
    display: "flex",
    justifyContent: "center",
    alignItems: "stretch",
    textAlign: "center",
  },
  listItemAvatar: {},
  listItemPrimary: {},
  listItemSelected: {
    backgroundColor: Theme.colors.accentLight,
  },

  largeFont: {
    fontSize: SPACING * 4,
  },
  mediumFont: {
    fontSize: SPACING * 3,
  },

  defaultPadding: {
    padding: SPACING,
  },

  fab: {
    position: "fixed",
    bottom: SPACING * 7,
    right: SPACING * 3,
    zIndex: 1,
  },

  selectable: {
    margin: SPACING,
    padding: SPACING,
    borderColor: Theme.colors.accentLight,
    borderWidth: 1,
    // boxSizing: "border-box",
  },
  selected: {
    backgroundColor: Theme.colors.accentLight,
  },

  textAlignLeft: {
    textAlign: "left",
  },
});

export default commonStyles;
